import { render, staticRenderFns } from "./ed-create-component-course.component.vue?vue&type=template&id=495ff66c&scoped=true&"
import script from "./ed-create-component-course.component.ts?vue&type=script&lang=ts&"
export * from "./ed-create-component-course.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-component-course.component.scss?vue&type=style&index=0&id=495ff66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ff66c",
  null
  
)

export default component.exports